import React, { Component } from 'react'
import WindowBreakpoints from '@otavamedia/om-component-library/lib/util/WindowBreakpoints'
import { breakpoints } from '@otavamedia/om-component-library/lib/lib/utils'

export default class TMWindowBreakpoints extends Component {
  render () {
    return <WindowBreakpoints breakpointSteps={breakpoints} {...this.props} />
  }
}
